var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "mergeModal",
    attrs: {
      id: "merge-client-profile-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
    },
    on: { hidden: _vm.resetData, show: _vm.handleShow },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("client-profile.actions.mergeClientProfile")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("client-profile.messages.mergeProfileModalText")
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "select-client-profile-container" } },
              [
                _c("select2", {
                  ref: "selectClientProfile",
                  attrs: {
                    id: "select-client-profile",
                    name: "select-client-profile",
                    data: _vm.profilesByBoard,
                    options: _vm.selectOptions,
                    value: _vm.clientProfileToMerge.id,
                    "format-data": _vm.formatData,
                    "init-on-mounted": false,
                  },
                  on: { change: _vm.handleSelectClientProfile },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "d-none",
                    attrs: { for: "select-client-profile" },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.doorr.clientProfile")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.clientProfileToMerge.id
              ? _c("merge-client-profile-warning", {
                  attrs: {
                    "client-profile-origin": _vm.clientProfileOrigin,
                    "client-profile-to-merge": _vm.clientProfileToMerge,
                    "show-profile-indicator": _vm.shouldShowProfileIndicator,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.clientProfileToMerge.id
              ? _c("v-client-table", {
                  key: _vm.clientProfileToMerge.id,
                  staticClass: "vue-custom-table no-pagination",
                  attrs: {
                    data: _vm.tableData,
                    columns: _vm.columns,
                    options: _vm.options,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "h__clientProfileOrigin",
                        fn: function () {
                          return [
                            _c(
                              "client-profile-name-label",
                              {
                                attrs: {
                                  "client-profile": _vm.clientProfileOrigin,
                                },
                              },
                              [
                                _vm.shouldShowProfileIndicator
                                  ? _c("span", [
                                      _vm._v(
                                        "\n            (" +
                                          _vm._s(
                                            _vm.$t(
                                              "client-profile.messages.thisProfile"
                                            )
                                          ) +
                                          ")\n          "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "h__clientProfileToMerge",
                        fn: function () {
                          return [
                            _c("client-profile-name-label", {
                              attrs: {
                                "client-profile": _vm.clientProfileToMerge,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "mergeProperty",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("p", { staticClass: "mb-0 grey-text" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(row.label) +
                                  "\n        "
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "clientProfileOrigin",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "pretty p-jelly p-primary mr-2",
                                class: {
                                  "p-icon p-round": _vm.isCheckbox(
                                    row.inputType
                                  ),
                                  "p-round p-smooth p-default": !_vm.isCheckbox(
                                    row.inputType
                                  ),
                                },
                              },
                              [
                                _c("input", {
                                  key: row.key + "-origin",
                                  attrs: {
                                    id: row.key + "-origin",
                                    type: row.inputType,
                                    name: row.key,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleChangeMergeProperty({
                                        mergeProperty: row.key,
                                        clientProfileSelection: "origin",
                                        checked: $event.target.checked,
                                        type: row.inputType,
                                      })
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "state p-primary",
                                    class: {
                                      "p-success": _vm.isCheckbox(
                                        row.inputType
                                      ),
                                    },
                                  },
                                  [
                                    _vm.isCheckbox(row.inputType)
                                      ? _c("icon", {
                                          staticClass: "icon",
                                          attrs: { name: "check" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("label"),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "clientProfileToMerge",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "pretty p-jelly p-primary mr-2",
                                class: {
                                  "p-icon p-round": _vm.isCheckbox(
                                    row.inputType
                                  ),
                                  "p-round p-smooth p-default": !_vm.isCheckbox(
                                    row.inputType
                                  ),
                                },
                              },
                              [
                                _c("input", {
                                  key: row.key + "-to-merge",
                                  attrs: {
                                    id: row.key + "-to-merge",
                                    type: row.inputType,
                                    name: row.key,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleChangeMergeProperty({
                                        mergeProperty: row.key,
                                        clientProfileSelection: "toMerge",
                                        checked: $event.target.checked,
                                        type: row.inputType,
                                      })
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "state p-primary",
                                    class: {
                                      "p-success": _vm.isCheckbox(
                                        row.inputType
                                      ),
                                    },
                                  },
                                  [
                                    _vm.isCheckbox(row.inputType)
                                      ? _c("icon", {
                                          staticClass: "icon",
                                          attrs: { name: "check" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("label"),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2840991830
                  ),
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "inline-prompt",
              {
                staticClass: "bold text-gray clickable",
                attrs: {
                  "confirmation-text": _vm.$t(
                    "client-profile.actions.confirmMergeClientProfile"
                  ),
                  "accept-button-type": "primary",
                  disabled: !_vm.isValid,
                },
                on: { accept: _vm.handleSubmit },
                scopedSlots: _vm._u([
                  {
                    key: "preConfirmationContent",
                    fn: function () {
                      return [
                        _c("merge-client-profile-warning", {
                          attrs: {
                            "client-profile-origin": _vm.clientProfileOrigin,
                            "client-profile-to-merge": _vm.clientProfileToMerge,
                            "show-profile-indicator":
                              _vm.shouldShowProfileIndicator,
                            "text-class": "text-grey",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm._v(" "),
                _c(
                  "simple-button",
                  { attrs: { loading: _vm.loading, disabled: !_vm.isValid } },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("client-profile.actions.mergeClientProfile")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }